<template>
  <div
    class="bg-white rounded box-shadow p-3 mb-1"
    style="padding-bottom:1px !important"
  >
    <div class="row">
      <div
        v-if="show"
        class="alert alert-danger alert-dismissible fade show"
        role="alert"
      >
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br />
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <h5 class="loat-left">06. Business Information</h5>
      </div>
      <div class="col float-right">
        <b-button
          v-b-modal.business-modal
          type="button"
          @click="
            $bvModal.show('business-modal'), getPersonStructures(), resetForm()
          "
          class="btn btn-success float-right btn-sm mb-1 text-black float-right"
        >
          Add Business
          <i class="fas fa-plus"></i>
        </b-button>
      </div>
    </div>

    <div class="bg-white rounded box-shadow">
      <div class="guide with-sidebar">
        <div class="scrollable-table">
          <table class="table dt-table table-striped table-long">
            <thead>
              <tr>
                <th>#</th>
                <th>Stru Info</th>
                <th>Name of Business</th>
                <th>Business Operator</th>
                <th>Father's Name</th>
                <th>Mother's Name</th>
                <th>Type of Business</th>
                <th>Address</th>
                <th>Capital</th>
                <th>Yearly Income</th>
                <th># of Employees</th>
                <th>Trade Lic no.</th>
                <th>VAT Reg. no</th>
                <th>TIN no.</th>
                <th>Deposit</th>
              </tr>
            </thead>
            <tbody>
              <tr li v-for="(business, index) in businesses" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  StruID : <b>{{ business.structures_land.id }}</b>
                </td>
                <td>{{ business.business_name }}</td>
                <td>{{ business.operator_name }}</td>
                <td>{{ business.operator_father }}</td>
                <td>{{ business.operator_mother }}</td>
                <td>{{ business.business_type }}</td>
                <td>{{ business.address }}</td>
                <td>{{ business.capital }}</td>
                <td>{{ business.yearly_income }}</td>
                <td>{{ business.employees_no }}</td>
                <td>{{ business.trade_licensing_no }}</td>
                <td>{{ business.vat_reg_no }}</td>
                <td>{{ business.tin_no }}</td>
                <td>{{ business.advance_deposite }}</td>
                <td>
                  <b-button
                    variant="warning"
                    class="btn btn-warning btn-xs waves-effect waves-light  mr-2"
                    @click.prevent="
                      getBusiness(business.id),
                        getPersonStructures(),
                        $bvModal.show('business-modal')
                    "
                  >
                    <i class="far fa-edit"></i>
                  </b-button>
                  <b-button
                    variant="danger"
                    class="btn btn-warning btn-xs waves-effect waves-light"
                    @click.prevent="softDelete(business.id)"
                  >
                    <i class="far fa-trash-alt"></i>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <modal-create-business
      :business="business"
      :btn_edit="btn_edit"
      :structures="structures"
      @getPersonBusinesses="getPersonBusinesses"
      @resetForm="resetForm"
      @getPersonStructures="getPersonStructures"
    ></modal-create-business>
  </div>
</template>

<script>
import http from "@state/http";
import appConfig from "@src/app.config";

import ModalCreateBusiness from "../../modals/ModalCreateBusiness";

export default {
  name: "business",
  props: [],
  page: {
    title: "Fill up SES Form/Business",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { ModalCreateBusiness },
  data() {
    return {
      structures: [],
      businesses: [],
      business: {},
      btn_edit: false,
      validation_errors: {},
      show: false
    };
  },
  mounted() {
    this.business.ses_id = this.$route.params.ses_id;
    this.getPersonBusinesses();
  },
  methods: {
    resetForm() {
      this.btn_edit = false;
      this.business = {};
      this.business.ses_id = this.$route.params.ses_id;
    },

    getBusiness(id) {
      this.btn_edit = true;
      http.get("api/ses/businesses/" + id + "/edit").then(response => {
        if (!response.data.error) {
          this.business = response.data.business;
        }
      });
    },
    getPersonBusinesses() {
      http
        .get("api/ses/businesses/" + this.$route.params.ses_id)
        .then(response => {
          if (!response.error) {
            this.businesses = response.data.businesses;
          }
        });
    },
    softDelete(busId) {
      http.delete("api/ses/businesses/" + busId).then(response => {
        if (!response.error) {
          this.$bvToast.toast(response.data.message, {
            title: "Success",
            autoHideDelay: 5000,
            variant: "success"
          });
          this.getPersonBusinesses();
        } else {
          this.$bvToast.toast("Update Failed", {
            title: "Error",
            autoHideDelay: 5000,
            variant: "danger"
          });
        }
      });
    },
    getPersonStructures() {
      http
        .post("api/ses/business/personStructures/" + this.$route.params.ses_id)
        .then(response => {
          if (!response.error) {
            this.structures = response.data.structures;
          }
        });
    }
  },

};
</script>
